import React from "react";
import { useDispatch } from "react-redux";
import Modal from "@visiblethread/react-components/dist/components/Modal";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { hideModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import PropTypes from "prop-types";
import {
  passwordExpiry,
  updateAuthToUsernamePassword,
} from "slices/systemAdmin/actions/authentication";

const EnableUsernamePasswordModal = ({
  isUsernamePassword,
  expiry,
  password,
}) => {
  const dispatch = useDispatch();

  const handleConfirmation = () => {
    if (isUsernamePassword) {
      dispatch(passwordExpiry(expiry));
    } else {
      dispatch(updateAuthToUsernamePassword(password));
    }
  };
  const handleCancel = () => {
    dispatch(hideModal(modalTypes.ENABLE_USERNAME_PASSWORD));
  };

  const modalBody = () => (
    <div className="enable__username_password__modal__body">
      <p>
        This will immediately change the authentication method of your
        deployment. Changing this setting will terminate your session and any
        other active sessions. Would you like to continue?
      </p>
    </div>
  );

  return (
    <Modal
      data-test="enableUsernamePasswordModal"
      className="fade-in"
      show
      onDismiss={handleCancel}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <b>Are you sure?</b>
      </Modal.Header>
      <Modal.Body>{modalBody()}</Modal.Body>
      <Modal.Footer>
        <Button
          data-test="saveButton"
          variant={buttonVariants.primary}
          onClick={() => {
            handleConfirmation();
          }}
          disabled={false}
          content="Confirm"
        />
        <Button
          data-test="cancelButton"
          variant={buttonVariants.secondary}
          onClick={handleCancel}
          content="Cancel"
        />
      </Modal.Footer>
    </Modal>
  );
};

export default EnableUsernamePasswordModal;

EnableUsernamePasswordModal.propTypes = {
  isUsernamePassword: PropTypes.bool.isRequired,
  expiry: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
};
